import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
      <footer>
        &copy; {new Date().getFullYear()} Eo Arts. Tous droits réservés.
      </footer>
  );
};

export default Footer;